// src/components/common/PageIntro.js — 공개 서브페이지 머리말 (경로 + 제목 + 설명)
import React from 'react';
import { Link } from 'react-router-dom';
import './PageIntro.scss';

/**
 * @param {string} title 페이지 제목 (h1)
 * @param {string} [description] 한 줄 설명
 * @param {Array<{label: string, to?: string}>} [trail] 홈 다음의 경로. 마지막 항목은 현재 페이지.
 * @param {boolean} [narrow] 본문 폭이 800px 인 페이지 — 머리말 왼쪽 끝을 본문과 맞춤
 * @param {React.ReactNode} [children] 제목 아래 보조 영역 (검색창 등)
 */
const PageIntro = ({ title, description, trail = [], narrow = false, children }) => {
  const crumbs = trail.length ? trail : [{ label: title }];
  return (
    <div className={`page-intro${narrow ? ' page-intro--narrow' : ''}`}>
      <div className="gt-container">
        <nav className="page-intro__crumbs" aria-label="현재 위치">
          <ol>
            <li><Link to="/">홈</Link></li>
            {crumbs.map((c, i) => (
              <li key={`${c.label}-${i}`}>
                {c.to && i < crumbs.length - 1 ? <Link to={c.to}>{c.label}</Link> : <span aria-current="page">{c.label}</span>}
              </li>
            ))}
          </ol>
        </nav>
        <h1 className="page-intro__title gt-display">{title}</h1>
        {description && <p className="page-intro__desc">{description}</p>}
        {children}
      </div>
    </div>
  );
};

export default PageIntro;
